export default {
    email_template_edit: '修改模版',
    template_add: '新增模版',
    email_template_add: '添加邮件模版',
    email_insert_tag: '插入标签',
    email_tag_warning: '替换标签只能替换系统内注册的用户，非系统用户无法替换',
    email_language: '类型',
    email_title: '标题',
    email_enter_template_name: '请输入模版名称',
    email_sender_name: '发件人名称',
    email_reply_email: '接收回信Email',
    email_subject: '主题',
    email_template_content: '模版内容',
    email_status: '是否启用',
    email_detail_title: '邮件内容',
    email_recipient: '邮箱',
    email_sender: '发送者',
    email_send_time: '发送时间',
    email_provider_status: '运营商发送状态',
    email_response_id: '发送返回值',
    email_content_label: '邮件内容：',
    sms_detail_title: '短信内容',
    sms_recipient: '手机号',
    sms_content_label: '短信内容',
    confirm_info_correct: '请确认以下信息是否正确',
    email_list_total: '要发送的列表共',
    items: '条',
    recipient_type: '中外宾',
    email_template: '邮件模版',
    sys_template: '系统模版',
    email_target_list: '邮件号码列表',
    btn_back: '返 回',
    btn_send_immediately: '立即发送',
    preview_title: '预览',
    email_balance_available: '可用金额',
    email_price: '邮件价格',
    email_sendable_count: '可发邮件数',
    btn_recharge_online: '在线充值',
    email_recipient: '收件人',
    email_please_select_recipient: '请选择收件人',
    recipient_type_china: '中宾',
    recipient_type_abroad: '外宾',
    email_custom_address: '自定义邮件地址',
    email_batch_input_hint: '批量时每一个号码占一行',
    email_batch_limit_tip: '注：最多不能超过一万条',
    please_select_language: '请选择语言',
    template_language_zh: '中文模版',
    template_language_en: '英文模版',
    please_select_template: '请选择模版',
    please_enter_sender_name: '请输入发件人名称',
    please_enter_reply_email: '请输入接收回信Email',
    please_enter_theme: '请输入主题',
    email_content: '邮件内容',
    please_enter_email_content: '请输入邮件内容',
    btn_submit_preview: '提交预览',
    email_recipient_count: '收件人数量',
    sms_preview_title: '短信预览',
    recipient_type: '中外宾',
    sms_target_list: '号码列表',
    sms_template: '短信模版',
    sms_content_example: '短信内容',
    sms_channel: '渠道',
    sms_sign: '短信签名',
    send_success: '发送成功',
    sms_price: '短信价格',
    sms_sendable_count: '可发短信数',
    sms_list: '短信列表',
    sms_template: '短信模版',
    please_select_sms_template: '请选择短信模版',
    sms_custom_template: '自定义短信',
    please_enter_sms_content: '请输入短信内容',
    sms_max_length_limit: '一次发放短信内容的最长字符数不超过500字符',
    sms_total_count: '短信总数',
    sms_billing_rule: '条/70字符（不足按70字符计算）',
    sms_tips_with_tags: '注意：如果短信内容包含标签，则短信内容字符以替换标签后的字符数为准！',
    sms_billing_details:
        '短信计费规则：70字以内计费一条，超过70字,67个字计费一条，短信最多可以支持500字。按字符计算，1个英文字母，1个数字，1个标点，1个空格，1个汉字，都算1个字。长短信整条短信按67的倍数扣费。',
    please_enter_sms_list: '请填写短信列表',
    sms_template_edit: '编辑短信模板',
    sms_template_add: '添加短信模板',
    sms_enter_title: '请输入短信标题',
    sms_enable: '启用',
    sms_disable: '关闭',
    email_params_config_zh: '中文参数配置',
    email_params_config_en: '英文参数配置',
    sender_name_placeholder: '请输入发件人名称',
    receive_email_placeholder: '请输入发送/接收邮箱',
    email_format_error: '邮箱格式不正确',
    merchant_contact_label: '商户联系方式 （可用于邮件模板统一标签调用）',
    merchant_contact_placeholder: '请输入商户联系方式',
    submit_button_text: '立即提交',
    setting_success_message: '设置成功',
    email_search_email: '邮箱',
    email_search_status: '发送状态',
    email_status_success: '发送成功',
    email_status_failure: '发送失败',
    email_search_button: '查 询',
    email_total_count: '总计：{value}条',
    email_count: '数量（条）',
    email_operation: '操作',
    email_preview: '点击查看',
    download_template: '下载模板',
    upload_excel_tip: '温馨提示:上传Excel数据必须包含{value}列并将{value}放在第一列',
    click_or_drag_upload: '点击或者拖拽上传文件',
    confirm_send_content: '确认发送吗？',
    please_upload_file: '请上传后缀为{type}的格式',
    email_template_chinese: '中文邮件模版',
    email_template_english: '英文文邮件模版',
    table_id: 'ID',
    template_type: '模版类型',
    sms_search_phone: '手机号码',
    sms_search_phone_placeholder: '请输入手机号码',
    sms_table_phone: '手机',
    click_insert_tag: '点击插入标签',
    send_sms: '发送短信',
    characters: '字',
    help_doc: '帮助文档',
    send_email: '发送邮件',
    email_please_enter_email_content: '请输入邮件内容'
};
